import React, { memo } from 'react';
import { trackEvent } from '../../../../shared/utils/analytics';

function ViewModeSwitch({ filter, onFilterChange }) {
  return (
    <div className="task-view-mode-switch text-non-selectable" role="tablist" aria-label="View mode">
      <button
        type="button"
        role="tab"
        aria-selected={filter !== 'prioritize'}
        className={`task-view-mode-switch-option ${filter !== 'prioritize' ? 'task-view-mode-switch-option-active' : ''}`}
        onClick={() => {
          if (filter === 'prioritize') {
            trackEvent('organize_clicked');
            onFilterChange('all');
          }
        }}
      >
        <svg width="12" height="12" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <rect width="6" height="6" x="10" y="26" fill="currentColor" rx="1" ry="1" />
          <path
            fill="currentColor"
            d="M15 16h-4a1 1 0 0 0-1 1v1.2H5.8V12H7a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1.2v17.8H11a.8.8 0 1 0 0-1.6H5.8v-8.4H10V21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1"
          />
          <path fill="currentColor" d="M33 8H10v2h23a1 1 0 0 0 0-2" />
          <path fill="currentColor" d="M33 18H18v2h15a1 1 0 0 0 0-2" />
          <path fill="currentColor" d="M33 28H18v2h15a1 1 0 0 0 0-2" />
        </svg>
        Organize
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={filter === 'prioritize'}
        className={`task-view-mode-switch-option ${filter === 'prioritize' ? 'task-view-mode-switch-option-active' : ''}`}
        onClick={() => {
          if (filter !== 'prioritize') {
            trackEvent('prioritize_clicked');
            onFilterChange('prioritize');
          }
        }}
      >
        <svg width="12" height="12" viewBox="0 0 256 256" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden>
          <path
            fill="currentColor"
            d="M216 48H40a8 8 0 0 0-8 8v152a16 16 0 0 0 16 16h40a16 16 0 0 0 16-16v-48h48v16a16 16 0 0 0 16 16h40a16 16 0 0 0 16-16V56a8 8 0 0 0-8-8M88 208H48v-80h40Zm0-96H48V64h40Zm64 32h-48V64h48Zm56 32h-40v-48h40Zm0-64h-40V64h40Z"
          />
        </svg>
        Prioritize
      </button>
    </div>
  );
}

export default memo(ViewModeSwitch);
